webpackJsonp([352],{

/***/ 1003:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX V2.1.1Rc.13 released | VUX - Vue.js Mobile UI Component Framework", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1818:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1003),
  /* template */
  __webpack_require__(2205),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/v2.1.1-rc.13-79.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.1.1-rc.13-79.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-46d4d77a", Component.options)
  } else {
    hotAPI.reload("data-v-46d4d77a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2205:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.1.1Rc.13 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/cell.html"
    }
  }, [_vm._v("Cell")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Support Group label styles #1110")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup-picker.html"
    }
  }, [_vm._v("PopupPicker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Use gray for cancel text color")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/radio.html"
    }
  }, [_vm._v("Radio")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix not support Number and not reactive #1115")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/search.html"
    }
  }, [_vm._v("Search")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add slot:right")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/step.html"
    }
  }, [_vm._v("Step")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] use export instead of module.exports")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/toast.html"
    }
  }, [_vm._v("Toast")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix After the call is not set webkitOverflowScrolling for touch")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-header.html"
    }
  }, [_vm._v("XHeader")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix cannot set empty backText #1109 @erguotou520")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-46d4d77a", module.exports)
  }
}

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1818);

/***/ })

});


// WEBPACK FOOTER //
// 352.d62632d8.js